<template>
  <div class="default-layout">
    <div
      :class="{
        'user-box': true,
        'user-box_minimize': minimizeSidebar
      }"
    >
      <TheSidebar/>
    </div>

    <div
      class="content-box"
      :class="{ 'content-box--locked': saveLoading }"
    >
      <div
        v-if="saveLoading"
        class="content-box__overlay"
        aria-busy="true"
      />
      <div class="header" v-if="isShowHeader">
        <h1 class="header__title">{{title}}</h1>
        <span class="header__line"></span>
        <CloseIcon @click="goBack" v-if="visibleClose"/>
      </div>
      <slot/>
      <div class="footer" v-if="isShowFooter">
        <div class="footer__default" v-if="!customFooter">
          <div class="footer__date">
            <BaseBtnNew v-if="isHistory" name='История версий' @clickBtn="$emit('storyChange')">
              <HistoryVersionIconNew/>
            </BaseBtnNew>
            <p class="footer__date-item">Дата создания: <span>{{ dateCreated }}</span></p>
            <p v-if="isPublish" class="footer__date-item">Дата публикации: <span>{{datePublish}}</span></p>
          </div>
          <div class="footer__manage">
            <BaseBtnNew
              name="Cохранить"
              @clickBtn="$emit('saveForm')"
              :disabled="saveDisabled"
              :loader="saveLoading"
            >
              <SaveIconNew/>
            </BaseBtnNew>
            <BaseBtnNew
              v-if="isPublish && !isPublished"
              @clickBtn="$emit('publishForm', !isPublished)"
              name="Опубликовать"
              green
              :disabled="publishDisabled"
            >
              <PublishIconNew />
            </BaseBtnNew>
            <BaseBtnNew
              v-if="isPublish && isPublished"
              @clickBtn="$emit('removePublishForm', !isPublished)"
              name="Снять с публик."
            >
              <removePublishIcon/>
            </BaseBtnNew>
          </div>
        </div>
        <slot name="customFooter"  v-if="customFooter"></slot>
      </div>
    </div>
    <WindowError v-if="warningModal" />
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

import router from '@/router'

import TheSidebar from '@/components/blocks/TheSidebar.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import WindowError from '@/components/modals/WindowError.vue'
import HistoryVersionIconNew from '@/components/icons/HistoryVersionIconNew.vue'
import PublishIconNew from '@/components/icons/PublishIconNew.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'
import removePublishIcon from '@/components/icons/removePublishIcon.vue'

export default {
  name: 'LayoutDefault',
  components: {
    TheSidebar,
    WindowError,
    BaseBtnNew,
    HistoryVersionIconNew,
    PublishIconNew,
    removePublishIcon,
    SaveIconNew,
    CloseIcon
  },
  props: {
    isShowHeader: {
      type: Boolean,
      default: false
    },
    isShowFooter: {
      type: Boolean,
      default: false
    },
    isPublish: {
      type: Boolean,
      default: true
    },
    isHistory: {
      type: Boolean,
      default: true
    },
    dataText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    customFooter: {
      type: Boolean,
      default: false
    },
    visibleClose: {
      type: Boolean,
      default: false
    },
    datePublish: {
      type: String,
      default: ''
    },
    dateCreated: {
      type: String,
      default: ''
    },
    saveDisabled: {
      type: Boolean,
      default: false
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    publishDisabled: {
      type: Boolean,
      default: true
    },
    isPublished: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const store = useStore()
    const minimizeSidebar = computed(() => {
      return store.getters.getMinimizeSidebar
    })

    const warningModal = computed(() => {
      return store.getters.getWarningModal
    })

    const hideShowSidebar = () => {
      store.commit('SetMinimizeSidebar', !minimizeSidebar.value)
    }
    const goBack = () => {
      router.go(-1)
    }

    return {
      minimizeSidebar,
      hideShowSidebar,
      goBack,
      warningModal
    }
  }
}
</script>

<style lang="scss" scoped>
.default-layout {
  display: flex;
  justify-content: space-between;
}

.user-box {
  position: relative;
  display: flex;
  width: 224px;
  // min-width: 300px;
  min-height: 100vh;
  transition: 0.3s;
  background-color: #1ba6da;
  background-color: #F5F5F5;
  z-index: 3;
  border: 1px solid #C8C8C8;

  &_minimize {
    width: 70px;
    // min-width: 66px;
    transition: 1s;
    :deep(.sidebar) {
      width: 70px;
      .person-name__first {
        display: none;
      }
    }
  }

  &__sticky {
    position: absolute;
    height: 100%;
    z-index: 3px;
    transform: translateX(244px);
    transition: 0.5s;

    &_hide {
      transform: translateX(-244px);
      transition: 0.5s;
    }
  }

  &__chevron {
    position: sticky;
    top: 30px;
    height: 30px;
    width: 36px;
    background-color: #1BA6DA;
    border-radius: 5px;
    cursor: pointer;

    @media(any-hover: hover) {
        &:hover {
          ::v-deep {
            .gg-chevron-left::after  {
              color: #6D6D6D;
              transition: 0.5s;
            }
          }
        }
    }

    &:active {
      ::v-deep {
        .gg-chevron-left:hover::after  {
          color: #595959;
          transition: 0.3s;
        }
      }
    }
  }
}

.content-box {
  height: 100vh;
  flex: 1;
  padding: 24px 24px 0 24px;
  min-width: calc(100vw - 244px);
  position: relative;
  overflow: auto;

  &--locked {
    pointer-events: none;
    user-select: none;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    cursor: wait;
  }

  .header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    &__title {
      font-size: 18px;
      font-weight: 700;
      color: #000000;
    }

    &__line {
      display: block;
      flex: 1;
      height: 2px;
      background-color: #C8C8C8;
    }
  }

  .footer {
    position: absolute;
    z-index: 4;
    bottom: 0;
    left: 0;
    background-color: #F5F5F5;
    padding: 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 2px solid #D6D6D6;

    &__default {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    &__date, &__manage {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    &__date {
      color: #000000;
      font-size: 18px;
      line-height: 1.4;
      span {
        font-size: 24px;
        font-weight: 700;
        color: #000000;
      }
      &-item {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
}

</style>
